/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  TextField,
  FormControl,
  InputLabel,
  IconButton,
  OutlinedInput,
  InputAdornment,
  FormHelperText,
  Snackbar,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  AlternateEmail, VpnKeyRounded, Visibility, VisibilityOff,
} from '@material-ui/icons';
import moment from 'moment';
import Alert from '@material-ui/lab/Alert';
import userActions from '../../../redux/actions/userActions';
import config from '../../../config';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  newAccountButton: {
    marginTop: theme.spacing(4),
  },
}));

const LoginForm = ({
  login, impersonateLogin, setCreateAccount, loggingIn, loggingError, userMail, adminMail,
}) => {
  const classes = useStyles();
  const closePlatform = new Date(config.START_CLOSING_PLATFORM);
  const endPlatform = new Date(config.END_CLOSING_PLATFORM);

  const [email, setEmail] = useState('');
  const [prefmsError, setPrefmsError] = useState(false);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorSnackBar, setErrorSnackBar] = useState(null);
  const [forbiddenCompany, setForbiddenCompany] = useState(false);
  const [maintenance, setMaintenance] = useState(false);
  const impersonate = Boolean(userMail && adminMail);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClick = (e) => {
    e.preventDefault();
    setPrefmsError(false);

    const emailToUse = impersonate ? userMail : email;

    if (emailToUse.includes('@prefmschutoulouse.onmicrosoft.com')) {
      setPrefmsError(true);
      return;
    }

    const loginAction = impersonate
      ? impersonateLogin(userMail, password, false, 'student', adminMail)
      : login(email, password);

    loginAction
      .then((res) => {
        if (!impersonate) {
          setForbiddenCompany(res === 'Company blocked');
          setMaintenance(res === 'Maintenance');
        }
      })
      .catch(() => {
        setErrorSnackBar({
          code: 2401,
          message: 'Erreur lors de la connexion',
          severity: 'warning',
        });
        setPrefmsError(true);
      });
  };

  // On choisit dynamiquement quel message d'erreur décrire
  let passwordErrorId;
  if (loggingError && !forbiddenCompany && !maintenance) {
    passwordErrorId = 'password-error-1';
  } else if (forbiddenCompany) {
    passwordErrorId = 'password-error-2';
  } else if (maintenance) {
    passwordErrorId = 'password-error-3';
  }

  return (
    <form className={classes.form} noValidate>
      <Snackbar
        role="alert"
        open={errorSnackBar !== null}
        onClose={() => { setErrorSnackBar(null); }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          severity={errorSnackBar !== null ? errorSnackBar.severity : 'info'}
          variant="filled"
          onClose={() => { setErrorSnackBar(null); }}
        >
          {`Error ${errorSnackBar?.code}: ${errorSnackBar?.message}`}
        </Alert>
      </Snackbar>

      {impersonate ? (
        <>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            label="Email utilisateur"
            value={userMail}
            InputProps={{
              readOnly: true,
              startAdornment: (
                <InputAdornment position="start">
                  <AlternateEmail />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            label="Adresse email administrateur"
            value={adminMail}
            InputProps={{
              readOnly: true,
              startAdornment: (
                <InputAdornment position="start">
                  <AlternateEmail />
                </InputAdornment>
              ),
            }}
          />
          <FormControl
            variant="outlined"
            fullWidth
            style={{ marginBottom: '1em' }}
          >
            <InputLabel htmlFor="password">Mot de passe administrateur *</InputLabel>
            <OutlinedInput
              id="password"
              error={loggingError}
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              startAdornment={(
                <InputAdornment position="start">
                  <VpnKeyRounded />
                </InputAdornment>
              )}
              endAdornment={(
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )}
              labelWidth={210}
            />
            {loggingError && (
              <FormHelperText error id="password-error">
                Mot de passe incorrect
              </FormHelperText>
            )}
          </FormControl>
        </>
      ) : (
        <>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={prefmsError}
            id="email"
            label="Adresse email"
            name="email"
            autoComplete="email"
            value={email || ''}
            onChange={(e) => setEmail(e.target.value.trim())}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AlternateEmail />
                </InputAdornment>
              ),
            }}
            autoFocus
          />
          {prefmsError && (
          <FormHelperText error id="email-error" style={{ marginBottom: '15px' }}>
            Adresse mail en @prefmschutoulouse.onmicrosoft.com bloquée par votre établissement
          </FormHelperText>
          )}

          <FormControl variant="outlined" fullWidth style={{ marginBottom: '1em' }}>
            <InputLabel htmlFor="password">Mot de passe *</InputLabel>
            <OutlinedInput
              id="password"
              aria-describedby={passwordErrorId}
              error={loggingError || forbiddenCompany || maintenance}
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              startAdornment={(
                <InputAdornment position="start">
                  <VpnKeyRounded />
                </InputAdornment>
          )}
              endAdornment={(
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
          )}
              labelWidth={105}
            />
            {loggingError && !forbiddenCompany && !maintenance && (
            <FormHelperText error id="password-error-1">
              Email ou mot de passe incorrect
            </FormHelperText>
            )}
            {forbiddenCompany && (
            <FormHelperText error id="password-error-2">
              Votre accès à la plateforme est temporairement suspendu.
              Si vous avez des questions, veuillez vous en référer à votre établissement et non à l'assistance.
            </FormHelperText>
            )}
            {maintenance && (
            <FormHelperText error id="password-error">
              La plateforme sera fermée du
              {' '}
              {moment(new Date(closePlatform)).format('DD/MM/YYYY')}
              {' '}
              au
              {' '}
              {moment(new Date(endPlatform)).format('DD/MM/YYYY')}
              {' '}
              compris. Merci de votre compréhension.
            </FormHelperText>
            )}
          </FormControl>
        </>
      )}

      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        onClick={(e) => handleClick(e)}
        aria-label="Se connecter"
      >
        {loggingIn ? 'Chargement...' : `Se connecter${config.PLATFORM === 'preprod' ? ' preprod' : ''}`}
      </Button>

      {!impersonate && (
        <Button
          className={classes.newAccountButton}
          fullWidth
          onClick={() => setCreateAccount()}
          variant="contained"
          aria-label="Créer un compte"
        >
          Créer un compte
        </Button>
      )}
    </form>
  );
};

LoginForm.defaultProps = {
  loggingIn: false,
  loggingError: false,
};

LoginForm.propTypes = {
  loggingIn: PropTypes.bool,
  login: PropTypes.func.isRequired,
  loggingError: PropTypes.bool,
  setCreateAccount: PropTypes.func.isRequired,
  userMail: PropTypes.string,
  adminMail: PropTypes.string,
  impersonateLogin: PropTypes.func.isRequired,
};

function mapState(state) {
  const { loggingIn, loggingError } = state.auth;
  return { loggingIn, loggingError };
}

const actionCreators = {
  login: userActions.login,
  impersonateLogin: userActions.impersonateLogin,
};

export default connect(mapState, actionCreators)(LoginForm);
